import { Component } from '@angular/core'
import { DocumentsPrefForm } from '@tv3/containers/documents/preferences/form/documents-pref-form'

@Component({
  selector: 'app-document-notifications-pref-table',
  templateUrl: './document-notifications-pref-table.component.html',
})
export class DocumentNotificationsPrefTableComponent extends DocumentsPrefForm {}
